import React from 'react';
import FeatureCard from './FeatureCard';
import { FiAward, FiFileText, FiHeadphones, FiLayers } from 'react-icons/fi';

export default function Features() {
  return (
    <section className="bg-white px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div className="rounded-[32px] bg-slate-950 p-8 text-white shadow-[0_25px_70px_-40px_rgba(15,23,42,0.8)] sm:p-10 lg:sticky lg:top-24">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-indigo-300">Why choose us</p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight sm:text-4xl">Everything you need to manage your subscription in one place.</h2>
          <p className="mt-5 max-w-xl text-base leading-8 text-slate-300">
            Learnwebcare offers you a simple way to manage subscriptions, contact agents, and access support from partner-trained teams.
          </p>

          <div className="mt-8 space-y-4">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <p className="text-sm font-medium text-white">Simplified management</p>
              <p className="mt-1 text-sm leading-6 text-slate-300">Fill in the email address you used when you subscribed and reach your customer account in one click.</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <p className="text-sm font-medium text-white">Expert agents</p>
              <p className="mt-1 text-sm leading-6 text-slate-300">Contact the agents by live chat or by phone if you need help with your subscription or any other question.</p>
            </div>
          </div>
        </div>

        <div className="grid gap-5 md:grid-cols-2">
          <FeatureCard title="Simplified management of your subscriptions" icon={<FiLayers />} eyebrow="Management" className="md:col-span-2">
            Learnwebcare offers you to easily manage different subscriptions. Fill in the e-mail address you used when you subscribed and reach your customer account in one click.
          </FeatureCard>

          <FeatureCard title="All the essential information" icon={<FiFileText />} eyebrow="Control">
            All the essential information is there to give you maximum control of your subscriptions. You can also contact the agents to ask for help, unsubscribe or make a complaint.
          </FeatureCard>

          <FeatureCard title="Agents at your service" icon={<FiHeadphones />} eyebrow="Support">
            Our agents are experts in after-sales services and have all the answers to your questions. We work 7 days per week, so you can contact the agents by live chat or by phone.
          </FeatureCard>

          <FeatureCard title="Recognized expertise" icon={<FiAward />} eyebrow="Expertise" className="md:col-span-2">
            We provide the after-sales service of several partner sites, which are all satisfied with our services. Our expertise provides the support for every single client.
          </FeatureCard>
        </div>
      </div>
    </section>
  );
}
